export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ILink {
  to: string;
  label: React.ReactNode;
  target?: React.HTMLAttributeAnchorTarget;
}

export interface IFieldAction {
  label: React.ReactNode;
  onClick: React.MouseEventHandler;
}
